import { useEffect } from 'react';

/**
 * Pins the document (html element) so it can never scroll while a full-viewport layout is mounted.
 *
 * The app shells are exactly one viewport tall (`h-screen overflow-hidden`) and scroll through an inner
 * container, but `body`/`#root` only carry `min-height: 100vh` — so the document itself stays scrollable.
 * Overlays portaled to `document.body` are positioned absolutely in document space (RingilDropdown,
 * CustomTooltip, PrimeReact panels), which pushes body's scroll height past the viewport. Anything that then
 * scrolls the document — pinch-zoom panning is the reliable way to hit it — slides the whole shell up: the
 * content is clipped, dead space shows below it, and the wheel cannot undo it because the wheel drives the
 * inner container, not the document.
 *
 * Only for layouts that own the full viewport. Public/error pages that scroll the body must not use this.
 */
const useLockDocumentScroll = () => {
  useEffect(() => {
    const html = document.documentElement;
    const previous = html.style.overflow;
    html.style.overflow = 'hidden';
    // Anything that already scrolled the document before the lock stays stuck there otherwise.
    html.scrollTop = 0;
    return () => {
      html.style.overflow = previous;
    };
  }, []);
};

export default useLockDocumentScroll;
